module.exports = __webpack_public_path__ + "static/media/logouticon.b02b3cf2.svg";